export default __webpack_public_path__ + "static/media/EOTProto1.66e44773.jpg";